import React from 'react';
// import Marquee from 'react-fast-marquee';
import {ImageReelWrapper, ImageReel, ImageReelItem} from './styles-hero';

const HeroImageSlider = () => {
	// const windowWidth = window.innerWidth;
	// const speed = windowWidth > 640 ? 0 : 20;
	const images = [
		'hero-slider-two.jpg',
		'hero-slider-three.jpg',
		'hero-slider-five.jpeg',
		'hero-slider-one.jpg',
		'hero-slider-four.jpg',
	];
	return (
		<ImageReelWrapper>
			<ImageReel>
				{/* <Marquee speed={speed}> */}
				{images.map((image, index) => (
					<ImageReelItem key={index} src={`assets/images/${image}`} />
				))}
				{/* </Marquee> */}
			</ImageReel>
		</ImageReelWrapper>
	);
};

export default HeroImageSlider;
